export default "__VITE_ASSET__Cfj48xB8__"